import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const ChangeStoreComponent = () => {
  const [stores, setStores] = useState([]);
  const { store, setStore } = useStateContext();

  useEffect(() => {
    axiosClient
      .get("customer/authenticated")
      .then((response) => {
        const allStores = response.data.customer.flatMap(
          (company) => company.Stores
        );
        setStores(allStores);
      })
      .catch((err) => console.log(err));
  }, []);

  if (stores.length !== 0) {
    return stores.map((s) =>
      s.name === JSON.parse(store).name ? null : (
        <>
          <Avatar
            alt={s.name}
            src={`${process.env.REACT_APP_PHOTO_URL}DB301_${s.id}_${s.name.replace(/[^a-zA-Z]/g, "")}/DB301_${s.id}_${s.name.replace(/[^a-zA-Z]/g, "")}_shop_${s.id}.jpg`}
            onClick={() => {
              setStore(JSON.stringify(s));
            }}
          />
          <Box sx={{ width: "4px" }} />
        </>
      )
    );
  }else{
    return null;
  }
};

export default ChangeStoreComponent;
